import { render, staticRenderFns } from "./errorAlert.vue?vue&type=template&id=b7796358"
import script from "./errorAlert.vue?vue&type=script&lang=js"
export * from "./errorAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports